import request from '@/api/request'
import type { SpringPage } from '@/api/types/domain'

/** 对标旧版 Admin/User——前台 `user` 表分页行 */
export interface PortalUserRow {
  id: number
  phone: string
  name: string
  status?: number | null
  addtime?: number | null
  discode?: number | null
  loginPassword?: string | null
}

export interface PortalUserPublic {
  id: number
  phone: string
  addtime?: number | null
  status?: number | null
  discode?: number | null
  money?: number | null
  addMoney?: number | null
  showVerifyFeeBanner?: boolean
  token?: string | null
  loginPassword?: string | null
}

/** userinfo + user 快照（管理员查看资料） */
export interface PortalUserProfile {
  user: PortalUserPublic
  userinfo: Record<string, unknown> | null
}

export function fetchPortalUsers(
  keyword: string | undefined,
  page: number,
  size: number,
  nameKeyword?: string | undefined,
) {
  return request.get<SpringPage<PortalUserRow>>('/api/admin/users', {
    params: {
      ...(keyword?.trim() ? { keyword: keyword.trim() } : {}),
      ...(nameKeyword?.trim() ? { name: nameKeyword.trim() } : {}),
      page,
      size,
    },
  })
}

export function createPortalUser(phone: string, password: string) {
  return request.post<PortalUserPublic>('/api/admin/users', { phone, password })
}

export function fetchPortalUserProfile(id: number) {
  return request.get<PortalUserProfile>(`/api/admin/users/${id}/profile`)
}

export function patchPortalUserUserinfo(id: number, body: Record<string, unknown>) {
  return request.patch<PortalUserProfile>(`/api/admin/users/${id}/userinfo`, body)
}

export function patchPortalUserStatus(id: number, status: 0 | 1) {
  return request.patch<PortalUserPublic>(`/api/admin/users/${id}/status`, { status })
}

export function patchPortalUserPassword(id: number, password: string) {
  return request.patch<{ status: number; msg: string }>(`/api/admin/users/${id}/password`, {
    password,
  })
}

export function patchPortalUserWithdrawalCode(id: number, code: string) {
  return request.patch<PortalUserPublic>(`/api/admin/users/${id}/withdrawal-code`, { code })
}

export function patchPortalUserPhone(id: number, phone: string) {
  return request.patch<PortalUserPublic>(`/api/admin/users/${id}/phone`, { phone })
}

export function sendPortalUserWithdrawalSms(id: number) {
  return request.post<{ status: number; msg: string }>(`/api/admin/users/${id}/send-withdrawal-sms`)
}

export function deletePortalUser(id: number) {
  return request.delete<{ status: number; msg: string }>(`/api/admin/users/${id}`)
}

export function patchPortalUserVerifyFeeBanner(id: number, enabled: boolean) {
  return request.patch<PortalUserPublic>(`/api/admin/users/${id}/verify-fee-banner`, {
    enabled,
  })
}

/** Admin proxy loan application — writes `order` for a user (see API docs). */
export interface AdminCreateLoanOrderBody {
  money: number | string
  months: number
  allowIncompleteProfile?: boolean
  createVerificationFeeDraft?: boolean
  signSnap?: string
}

export interface AdminCreateLoanOrderRes {
  status: number
  msg?: string
  loanId?: number
  orderNum?: string
  payurl?: string
}

export function createPortalUserLoanOrder(id: number, body: AdminCreateLoanOrderBody) {
  return request.post<AdminCreateLoanOrderRes>(`/api/admin/users/${id}/loan-orders`, body)
}

export interface RepairLoanOrderRes {
  status: number
  msg?: string
  action?: 'none' | 'restore' | 'create'
  loanId?: number
  orderNum?: string
}

/** 用户/提现存在但信贷订单缺失时，从回收站恢复或补建已审核订单 */
export function repairPortalUserLoanOrder(id: number) {
  return request.post<RepairLoanOrderRes>(`/api/admin/users/${id}/repair-loan-order`)
}
